import { cn } from '@endure/ui';

import { InfoIcon } from 'components/InfoIcon';

export interface CellProps extends React.HTMLAttributes<HTMLDivElement> {
  value: string | number | React.ReactNode;
  label?: string;
  tooltip?: string | React.ReactNode;
}

export const Cell: React.FC<CellProps> = ({ className, tooltip, label, value, ...otherProps }) => (
  <div className={cn('flex flex-col gap-y-1 whitespace-nowrap', className)} {...otherProps}>
    {!!label && (
      <div className="flex items-center">
        <span className="text-grey text-sm">{label}</span>

        {!!tooltip && <InfoIcon tooltip={tooltip} className="ml-2" />}
      </div>
    )}

    <div className="text-lg font-semibold tabular-nums">{value}</div>
  </div>
);
